import type { EnergyExposureFacilityOption } from '../ExposureService';

function compareDisplayLabel(a: EnergyExposureFacilityOption, b: EnergyExposureFacilityOption): number {
  return a.displayLabel.localeCompare(b.displayLabel, undefined, { sensitivity: 'base' });
}

/** Active facilities first (A–Z), then terminated facilities (A–Z). */
export function sortExposureFacilityOptions(options: EnergyExposureFacilityOption[]): EnergyExposureFacilityOption[] {
  const active = options.filter(option => !option.isTerminated);
  const terminated = options.filter(option => option.isTerminated);
  active.sort(compareDisplayLabel);
  terminated.sort(compareDisplayLabel);
  return [...active, ...terminated];
}
